import React from 'react';
import { ExternalLink } from 'lucide-react';

interface BulletPointLink {
    ref: string;
    url: string;
}

interface BulletPoint {
    links: BulletPointLink[];
    order: number;
    content: string;
}

interface BulletPointsSectionProps {
    bulletPoints: BulletPoint[];
}

const BulletPointsSection: React.FC<BulletPointsSectionProps> = ({ bulletPoints }) => {
    if (!bulletPoints?.length) return null;

    return (
        <div className="border-t border-gray-800 pt-6 mt-8 z-10 relative">
            <h2 className="text-lg font-semibold mb-6">Agent's News Summary</h2>
            
            <div className="grid gap-6">
                {bulletPoints
                    .sort((a, b) => a.order - b.order)
                    .map((point) => (
                        <div 
                            key={point.order} 
                            className="bg-transparent rounded-xl p-6 border border-gray-800/50 hover:border-gray-700/50 transition-colors"
                        >
                            <div className="flex gap-4">
                                {/* Number Circle */}
                                <div className="flex-shrink-0 w-8 h-8 bg-black rounded-full flex items-center justify-center border border-purple-500/20">
                                    <span className="text-white font-medium">
                                        {point.order}
                                    </span>
                                </div>

                                {/* Content and Links */}
                                <div className="flex-1">
                                    {/* Main Content with Inline References */}
                                    <p className="text-gray-300 text-sm leading-relaxed">
                                        {point.content}
                                        {point.links?.length > 0 && (
                                            <span className="ml-2">
                                                {point.links.map((link, index) => (
                                                    <React.Fragment key={link.ref}>
                                                       ( <a
                                                            href={link.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-blue-400 hover:text-blue-300 inline-flex items-center"
                                                        >
                                                             Ref {index + 1}
                                                            <ExternalLink className="w-3 h-3 ml-0.5" /> 
                                                           
                                                        </a> )
                                                        {index < point.links.length - 1 && ", "}
                                                    </React.Fragment>
                                                ))}
                                            </span>
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default BulletPointsSection;